import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Search } from 'lucide-react'
import { ReportFilters } from '../hooks/use-reports'

interface ReportsFiltersProps {
  filters: ReportFilters
  onFiltersChange: (filters: ReportFilters) => void
  showTypeFilter?: boolean
}

export function ReportsFiltersComponent({
  filters,
  onFiltersChange,
  showTypeFilter = false,
}: ReportsFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="relative flex-1 sm:max-w-xs">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Buscar relatorios..."
          value={filters.search ?? ''}
          onChange={(e) => onFiltersChange({ ...filters, search: e.target.value })}
          className="pl-9"
        />
      </div>

      <div className="flex gap-3">
        {showTypeFilter && (
          <Select
            value={filters.type ?? 'daily'}
            onValueChange={(value) =>
              onFiltersChange({ ...filters, type: value as 'daily' | 'weekly' })
            }
          >
            <SelectTrigger className="w-full sm:w-[150px]">
              <SelectValue placeholder="Tipo" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="daily">Diarios</SelectItem>
              <SelectItem value="weekly">Semanais</SelectItem>
            </SelectContent>
          </Select>
        )}

        <Select
          value={filters.period ?? 'week'}
          onValueChange={(value) =>
            onFiltersChange({
              ...filters,
              period: value as 'today' | 'week' | 'month' | 'all',
            })
          }
        >
          <SelectTrigger className="w-full sm:w-[160px]">
            <SelectValue placeholder="Periodo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="today">Hoje</SelectItem>
            <SelectItem value="week">Ultima semana</SelectItem>
            <SelectItem value="month">Ultimo mes</SelectItem>
            <SelectItem value="all">Todo periodo</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
